class State {
    constructor() {
        this.store = {}
    }
    static getInstance () {
        if (!this.instance) {
            this.instance = new State()
        }
        return this.instance
    }
}





// state.setState = (key, data) => {
//     state[key] = data
// }
//
// state.getState = (key) => {
//     return state[key]
// }

// export default state

export function setState(key, data) {
    let s = State.getInstance()
    s.store[key] = data
}

export function getState(key) {
    let s = State.getInstance()
    return s.store[key]
}

